import React, { useState, useEffect } from 'react';
import { DebounceInput } from 'react-debounce-input';
import { useQuery, useLazyQuery } from 'react-apollo';
import LoadingOverlay from 'react-loading-overlay';
import moment from 'moment';
import PropTypes from 'prop-types';
import {
  loaderStyle,
  dateFormats, NUMERIC_VALUE, ARTIST_OFFER_LIST_STATUS, staticConstants, getLocalUserData, EMPTY_MESSAGE_ICON_FE,
} from '../../../utils';
import MessageDetail from './MessageDetail';

import { GET_OFFER_LIST_QUERY, GET_UNSEEN_MESSAGES, GET_ACTIVE_ARTIST } from '../../../graphql-client/queries';


function MessageList(props) {
  const { offerId, openOfferDetail, toggleChatModal } = props;
  const [offerList, setOfferList] = useState(null);
  const [activeChatOffer, setActiveChatOffer] = useState(null);
  const [detailPageOpen, setDetailPageOpen] = useState(false);
  const { data: unSeenMessageData } = useQuery(GET_UNSEEN_MESSAGES);
  const [lastConversation, setLastConversation] = useState([]);
  const [messageLoading, setMessageLoading] = useState(false);
  const [hasOfferData, setHasOfferData] = useState(false);
  const userData = getLocalUserData();
  const [activeArtistQuery, { data: activeArtistData }] = useLazyQuery(GET_ACTIVE_ARTIST, { skip: userData.role !== staticConstants.ROLE.MANAGER });
  const [
    getOffers, { data: offersData, loading: getOffersLoading },
  ] = useLazyQuery(GET_OFFER_LIST_QUERY, {
    fetchPolicy: 'network-only',
    variables: {},
  });

  useEffect(() => {
    userData.role === staticConstants.ROLE.ARTIST && getOffers({ variables: { status: ARTIST_OFFER_LIST_STATUS.MESSAGE_BOARD } });
    activeArtistQuery();
  },
  []);

  useEffect(() => {
    userData.role === staticConstants.ROLE.MANAGER && activeArtistData
    && getOffers({ variables: { status: ARTIST_OFFER_LIST_STATUS.MESSAGE_BOARD, artistId: activeArtistData.activeArtist._id } });
  },
  [activeArtistData]);

  useEffect(() => {
    activeArtistData && userData.role === staticConstants.ROLE.MANAGER
     && getOffers({ variables: { status: ARTIST_OFFER_LIST_STATUS.MESSAGE_BOARD, artistId: activeArtistData.activeArtist._id } });
  },
  [activeArtistData]);
  const toggleDetailPage = () => {
    setDetailPageOpen(!detailPageOpen);
  };
  useEffect(() => {
    unSeenMessageData && setLastConversation(unSeenMessageData.unseenMessages);
  },
  [unSeenMessageData]);

  const getSortedOfferList = (offers) => {
    let sortedOfferData = offers.offerList.data;
    if (unSeenMessageData && !activeChatOffer) {
      const sortedUnseenMessageData = unSeenMessageData.unseenMessages.sort((a, b) => b.timestamp - a.timestamp);
      const recentMessages = [...sortedUnseenMessageData.filter((el) => el.unseenMessage), ...sortedUnseenMessageData.filter((el) => !el.unseenMessage)];
      sortedOfferData = recentMessages.map((el) => offers.offerList.data.find((offer) => offer._id === el.offerId)).filter((el) => el);
      sortedOfferData = [...sortedOfferData, ...offers.offerList.data.filter((el) => sortedOfferData.findIndex((so) => so._id === el._id) === -1)];
    }
    return sortedOfferData;
  };

  useEffect(() => {
    if (!activeChatOffer && offersData) {
      const sortedOfferList = getSortedOfferList(offersData);
      setHasOfferData(sortedOfferList && sortedOfferList.length > 0);
      setOfferList(sortedOfferList);
      setActiveChatOffer(offersData.offerList.data.find((el) => el._id === offerId) || sortedOfferList[0]);
    }
  }, [offersData, unSeenMessageData]);

  const getLastConversation = (chatOfferId) => {
    const data = lastConversation.filter((lc) => lc.offerId === chatOfferId);
    return data && data.length > 0 ? moment(data[0].timestamp).format(dateFormats.MESSAGE_TIME_FORMAT) : '';
  };

  const filterChatList = (value) => {
    const searchKey = value.toLowerCase();
    if (searchKey) {
      const filteredData = offerList.filter((elem) => elem.title.toLowerCase().includes(searchKey) || elem.clientName.toLowerCase().includes(searchKey));
      setOfferList(filteredData);
      return;
    }
    setOfferList(getSortedOfferList(offersData));
  };
  const renderOfferListing = (Offerdata) => Offerdata.map((el) => (
    <div
      className={`message-list-row ${activeChatOffer._id === el._id && 'active'}`}
      key={el._id}
      onClick={() => {
        setActiveChatOffer(el);
        toggleDetailPage();
      }}
    >
      <div className="message-list-row-image">
        <img
          src={el.clientLogo}
          alt="user"
          className="image-cover"
        />
      </div>
      <div
        className="message-list-row-detail"
      >
        <h4>{el.title}</h4>
        <p>{el.clientName}</p>
        <span>{getLastConversation(el._id)}</span>
      </div>
      {unSeenMessageData && unSeenMessageData.unseenMessages.find((um) => um.offerId === el._id && um.unseenMessage)
      && <span className="unread" /> }
    </div>
  ));

  return (
    <>
      <div className={`modal-message-list ${detailPageOpen ? 'hide' : 'show'}
       ${(!offerList || offerList.length <= 0) && !hasOfferData
        && !getOffersLoading ? 'no-initial-message' : ''}`}
      >
        <LoadingOverlay
          active={getOffersLoading || messageLoading}
          spinner
          text=""
          className="chatLoader"
          styles={loaderStyle}
        />
        {(!offerList || offerList.length <= 0) && !hasOfferData && !getOffersLoading && (
        <div className="empty-wrapper text-center">
          <img
            src={EMPTY_MESSAGE_ICON_FE}
            all="Message"
            alt="no message"
          />
          <h3 className="mt-3">No messages yet</h3>
          <span>
            You have no messages yet. Once you start, your
          </span>
          <span className="m-0">conversations will appear here.</span>
        </div>
        )}
        {offerList && hasOfferData && (
        <div className="message-list">
          <h1>All messages</h1>
          <div className="message-list-search">
            <div className="search">
              <DebounceInput
                minLength={NUMERIC_VALUE.TWO}
                type="search"
                placeholder="Search"
                debounceTimeout={NUMERIC_VALUE.THREE_HUNDRED}
                onChange={(event) => filterChatList(event.target.value)}
              />
              <span className="search-icon" />
            </div>
          </div>
          <div className="message-list-column">
            { offerList && renderOfferListing(offerList)}
          </div>
        </div>
        ) }
      </div>
      { activeChatOffer && offerList && (offerList.length > 0 || hasOfferData) && (
      <MessageDetail
        offerDetail={activeChatOffer}
        artistId={activeArtistData ? activeArtistData.activeArtist._id : userData._id}
        detailOpen={detailPageOpen}
        detailHide={toggleDetailPage}
        openOfferDetail={openOfferDetail}
        toggleChatModal={toggleChatModal}
        setMessageLoading={setMessageLoading}
      />
      ) }
    </>
  );
}

MessageList.propTypes = {
  offerId: PropTypes.string,
  openOfferDetail: PropTypes.func,
  toggleChatModal: PropTypes.func.isRequired,
};

MessageList.defaultProps = {
  offerId: null,
  openOfferDetail: null,
};
export default React.memo(MessageList);
